import React from 'react'
import update from 'immutability-helper';

export default class Import extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            allReceiveAlerts: false
        }
    }

    componentDidMount() {}

    componentWillUpdate(nextProps, nextState) {}

    startBuildiumImport(e) {}

    render(){
        const allReceiveAlerts = this.state.allReceiveAlerts;
        return (
            <div class="col-md-8 col-sm-7 col-xs-12">
                <div class="card">
                    <div class="header">
                        <h4 class="title"><i class="pe-7s-edit"></i> <small><i class="pe-7s-angle-right"></i></small> Import</h4>
                        <p class="category">Import your data</p>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12">
                                <p class="category"><b>Import Buildium Data</b></p>
                            </div>
                            <div class="col-md-6 col-sm-12 col-xs-12">
                                <div class="form-group">
                                    <label for="effective_date">Upload Rent Roll</label>
                                    <input class="form-control" type="file"/>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-12 col-xs-12">
                                <div class="form-group">
                                    <label for="effective_date">Upload Rental Owners</label>
                                    <input class="form-control" type="file"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-md-offset-5 col-sm-4 col-sm-offset-4 col-xs-4 col-xs-offset-3">
                                <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.startBuildiumImport.bind(this)}>
                                    Start Import
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="content">
                        <div class="row">
                            <div class="col-md-12">
                                <p class="category"><b>Import Tenant Cloud Data</b></p>
                            </div>
                            <div class="col-md-6 col-sm-12 col-xs-12">
                                <div class="form-group">
                                    <label for="effective_date">Upload Rent Roll</label>
                                    <input class="form-control" type="file"/>
                                </div>
                            </div>
                            <div class="col-md-6 col-sm-12 col-xs-12">
                                <div class="form-group">
                                    <label for="effective_date">Upload Rental Owners</label>
                                    <input class="form-control" type="file"/>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-4 col-md-offset-5 col-sm-4 col-sm-offset-4 col-xs-4 col-xs-offset-3">
                                <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.startBuildiumImport.bind(this)}>
                                    Start Import
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Settings/Data/Import.jsx